import { useState } from 'react'

const DOMAINS = [
  'Identity & Access Management',
  'Data Protection',
  'Endpoint Security',
  'Network Security',
  'Threat Management'
]

export default function AssessmentPage() {
  const [answers, setAnswers] = useState<Record<number, string>>({})

  const handleAnswer = (questionId: number, value: string) => {
    setAnswers(prev => ({ ...prev, [questionId]: value }))
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-slate-900 mb-2">
          Azure/M365 Maturity Assessment
        </h1>
        <p className="text-lg text-slate-600 mb-8">
          Evaluate your organization's security and compliance maturity across 5 key domains.
        </p>

        <div className="space-y-8">
          {DOMAINS.map((domain, domainIdx) => (
            <div
              key={domainIdx}
              className="bg-white rounded-lg shadow-md p-6 border-l-4 border-blue-500"
            >
              <h2 className="text-2xl font-semibold text-slate-800 mb-4">
                {domainIdx + 1}. {domain}
              </h2>

              <div className="space-y-4">
                {[1, 2, 3, 4, 5].map(q => (
                  <div key={`${domainIdx}-${q}`} className="border-b pb-4 last:border-b-0">
                    <p className="font-medium text-slate-700 mb-3">
                      Question {domainIdx * 5 + q}: {domain} maturity indicator
                    </p>
                    <div className="flex gap-3">
                      {['Not started', 'Planned', 'In progress', 'Complete'].map(option => (
                        <label
                          key={option}
                          className="flex items-center gap-2 cursor-pointer hover:bg-slate-50 p-2 rounded"
                        >
                          <input
                            type="radio"
                            name={`q-${domainIdx}-${q}`}
                            value={option}
                            checked={answers[domainIdx * 5 + q] === option}
                            onChange={() => handleAnswer(domainIdx * 5 + q, option)}
                            className="w-4 h-4"
                          />
                          <span className="text-sm text-slate-600">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 bg-blue-50 p-3 rounded flex items-center justify-between">
                <span className="text-sm font-medium text-slate-700">
                  Domain Progress
                </span>
                <div className="flex-1 mx-4 bg-slate-200 h-2 rounded-full overflow-hidden">
                  <div
                    className="bg-blue-500 h-full transition-all duration-200"
                    style={{
                      width: `${
                        (Object.values(answers).filter((_, i) =>
                          i >= domainIdx * 5 && i < (domainIdx + 1) * 5
                        ).length / 5) * 100
                      }%`,
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={() => console.log('Submit assessment', answers)}
          className="mt-8 w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Submit Assessment
        </button>
      </div>
    </div>
  )
}
